module.exports = __webpack_public_path__ + "img/Paso3Check.f1cb49b5.svg";